"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaType = exports.XHRBasePluginMethods = void 0;
var XHRBasePluginMethods;
(function (XHRBasePluginMethods) {
    XHRBasePluginMethods["HandleRequest"] = "handleRequest";
    XHRBasePluginMethods["HandleResponse"] = "handleResponse";
})(XHRBasePluginMethods || (exports.XHRBasePluginMethods = XHRBasePluginMethods = {}));
var MediaType;
(function (MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["BLOB"] = "application/octet-stream";
    MediaType["FORMDATA"] = "multipart/form-data";
    MediaType["FORMURLENCODED"] = "application/x-www-form-urlencoded";
    MediaType["STREAMEVENT"] = "text/event-stream";
})(MediaType || (exports.MediaType = MediaType = {}));
//# sourceMappingURL=types.js.map